import { mobileLargeMax, mobileMax, mobileXLargeMax } from '@propertypal/shared/src/constants/mediaQueries';
import AppBg from '@propertypal/shared/src/resources/bg/app-bg.jpg';
import PlayStoreImg from '@propertypal/shared/src/resources/images/android-download-btn.png';
import AppStoreImg from '@propertypal/shared/src/resources/images/app-download-btn.png';
import styled from 'styled-components';

export const Container = styled.div`
  background: url(${AppBg.src}) no-repeat 50% 50%;
  background-size: cover;
  padding-top: 110px;
  padding-bottom: 230px;

  @media screen and (max-width: 1195px) {
    padding: 110px 0;
  }

  @media screen and (${mobileLargeMax}) {
    padding: 80px 0;
  }
`;

export const Buttons = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 40px;
  width: 100%;

  @media screen and (${mobileLargeMax}) {
    width: 100%;
  }
`;

export const AppStore = styled.button`
  background: url(${AppStoreImg.src}) no-repeat;
  background-size: contain;
  width: 208px;
  height: 60px;
  margin-right: 20px;

  @media screen and (${mobileXLargeMax}) {
    margin-right: 5px;
    max-width: 208px;
    width: 175px;
    height: 60px;
  }

  @media screen and (${mobileMax}) {
    width: 150px;
    height: 60px;
  }
`;

export const PlayStore = styled.button`
  background: url(${PlayStoreImg.src}) no-repeat;
  background-size: contain;
  width: 182px;
  height: 60px;

  @media screen and (${mobileXLargeMax}) {
    width: 150px;
    height: 60px;
  }

  @media screen and (${mobileMax}) {
    width: 130px;
    height: 60px;
  }
`;
